import type { ObjectSchemaProperty } from "@/models"
import { castUnsafe } from "vue-utils"

export interface Filter {
	Property: ObjectSchemaProperty
	Operator: Operator
	Value: unknown
}

export interface SendableFilter {
	Property: string[]
	Operator: Operator
	Value: unknown
}

export enum Operator {
	Equals = "Equals",
	NotEquals = "NotEquals",
	GreaterThan = "GreaterThan",
	LessThan = "LessThan",
	In = "In",
	NotIn = "NotIn",
	StringContains = "StringContains",
	StringNotContains = "StringNotContains",
	Exists = "Exists",
	NotExists = "NotExists",
}

export function createEmptyFilter(): Filter {
	return {
		Property: castUnsafe(null),
		Operator: castUnsafe(null),
		Value: null,
	}
}

export function getOperatorText(operator: Operator): string {
	switch (operator) {
		case Operator.NotEquals:
			return "Does Not Equal"
		case Operator.GreaterThan:
			return "Greater Than"
		case Operator.LessThan:
			return "Less Than"
		case Operator.In:
			return "Is In"
		case Operator.NotIn:
			return "Is Not In"
		case Operator.StringContains:
			return "Contains"
		case Operator.StringNotContains:
			return "Does Not Contain"
		case Operator.NotExists:
			return "Does Not Exist"
		default:
			return String(operator)
	}
}
